import { render, staticRenderFns } from "./action-button.vue?vue&type=template&id=051dfd25&scoped=true&lang=pug&"
import script from "./action-button.vue?vue&type=script&lang=js&"
export * from "./action-button.vue?vue&type=script&lang=js&"
import style0 from "./action-button.vue?vue&type=style&index=0&id=051dfd25&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051dfd25",
  null
  
)

export default component.exports